'use client';

import {Languages} from '@shared/languages';
import {type AppFromBackapi} from '@utils/fetchAppsByPackageNames';
import {retryPromise} from '@utils/retryPromise';
import {lazy, Suspense} from 'react';

import {
  PlaceholderPicks,
  SearchBlock,
} from '@web-landing/components/SearchPicks';

import {SearchBlockType} from '@strapi/types/MainLanding';

import styles from './SearchPicksBlock.module.scss';

type Props = {
  selections?: Array<AppFromBackapi>;
  apiUrl?: string;
  showSearch: boolean;
  showPicks: boolean;
  searchBlock: SearchBlockType;
  locale?: Languages;
};
const MiniPicks = lazy(
  retryPromise(
    async () =>
      import(
        /* webpackChunkName: "MiniPicks" */ '@web-landing/components/SearchPicks/MiniPicks/MiniPicks'
      ),
    {fallback: {default: PlaceholderPicks}},
  ),
);

export const SearchPicksBlock = ({
  selections,
  apiUrl,
  showSearch,
  showPicks,
  searchBlock,
  locale,
}: Props) => {
  return (
    <>
      <div className={styles.searchWrapper}>
        {showSearch && (
          <SearchBlock
            requestUrl={apiUrl}
            searchBlock={searchBlock}
            locale={locale}
          />
        )}
      </div>
      {!!selections?.length && showPicks && (
        <Suspense fallback={<PlaceholderPicks apps={selections} />}>
          <MiniPicks apps={selections} metricsName="MiniPicks" />
        </Suspense>
      )}
    </>
  );
};
